'use client';

import { useKlimaMenu } from '@/app/(campaign)/wirfuersklima/KlimaMenuContext';
import { linkToString } from '@/storyblok/wirfuersklima/helper/urls';
import type { FooterStoryblok, PartialMenuItemStoryblok } from '@/storyblok/wirfuersklima/types';
import { type SbBlokData, storyblokEditable } from '@storyblok/react/rsc';
import classNames from 'classnames';
import Link from 'next/link';

import classes from './Footer.module.scss';

const Footer: React.FC<{ blok: FooterStoryblok }> = ({ blok }) => {
  const { isOpen: menuOpen } = useKlimaMenu();
  const copyright = blok?.Copyright?.replace('%%YEAR%%', new Date().getFullYear().toString());

  return (
    <footer
      className={classNames(classes['footer'], menuOpen && classes['footer--nav-open'])}
      {...storyblokEditable(blok as SbBlokData)}
    >
      <div className={classes['footer__wrapper']}>
        <div className={classes['footer__copyright']}>{copyright}</div>
        {blok?.Links?.length && (
          <nav className={classes['footer__navigation']}>
            {blok.Links.map((link: PartialMenuItemStoryblok) => (
              <Link
                key={link._uid}
                className={classes['footer__navigation__link']}
                href={link.link ? linkToString(link.link) : '#'}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </footer>
  );
};

export default Footer;
